import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Drawer from '@mui/material/Drawer'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart'

import { AgentPulse } from './StatusIndicators'
import { MONO } from '../theme/appTheme'

/**
 * The fixed strip down the left-hand side.
 *
 * On a wide screen it shows names; on a narrow one it collapses to icons only.
 * Both versions end with the same thing: an honest read on whether our feed is
 * actually alive.
 */
export default function SideRail({ status, isWide, width }) {
  const isLive = status === 'live'

  return (
    <Drawer
      variant="permanent"
      sx={{
        width,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          position: 'fixed',
          top: 0,
          left: 0,
          width,
          height: '100vh',
          boxSizing: 'border-box',
          overflowX: 'hidden',
          bgcolor: 'custom.rail',
          borderRight: '1px solid',
          borderColor: 'custom.line',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
        },
      }}
    >
      {isWide ? (
        <>
          <Box sx={{ p: '20px 18px 22px' }}>
            <Typography sx={{ fontSize: '0.9rem', fontWeight: 700, letterSpacing: '-0.01em' }}>
              Tally Pingdesk
            </Typography>
          </Box>

          <Box sx={{ px: '10px' }}>
            <Stack
              direction="row"
              sx={{
                alignItems: 'center',
                gap: '9px',
                p: '7px 9px',
                borderRadius: '6px',
                bgcolor: 'custom.chip',
                cursor: 'pointer',
              }}
            >
              <MonitorHeartIcon sx={{ fontSize: 18, color: 'custom.ink' }} />
              <Typography sx={{ fontSize: '0.82rem', fontWeight: 600 }}>Tally Monitor</Typography>
            </Stack>
          </Box>

          <Stack
            direction="row"
            sx={{
              alignItems: 'center',
              gap: '7px',
              mt: 'auto',
              p: '16px 18px',
              borderTop: '1px solid',
              borderColor: 'custom.line',
            }}
          >
            {/* Don't claim "online" when the socket is down — say what is actually true. */}
            <AgentPulse live={isLive} />
            <Typography sx={{ fontFamily: MONO, fontSize: '0.64rem', color: 'custom.ink2' }}>
              {isLive ? 'agent online' : 'agent offline'}
            </Typography>
          </Stack>
        </>
      ) : (
        <>
          <Box
            sx={{
              height: 44,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderBottom: '1px solid',
              borderColor: 'custom.line',
            }}
          >
            <Avatar
              variant="rounded"
              sx={{
                width: 22,
                height: 22,
                borderRadius: '6px',
                bgcolor: 'custom.ink',
                color: 'custom.invertInk',
                fontSize: '0.66rem',
                fontWeight: 700,
              }}
            >
              P
            </Avatar>
          </Box>

          <Box sx={{ py: '8px', display: 'flex', justifyContent: 'center' }}>
            <Tooltip title="Tally Monitor" placement="right">
              <Box
                sx={{
                  width: 36,
                  height: 32,
                  borderRadius: '6px',
                  bgcolor: 'custom.chip',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                }}
              >
                <MonitorHeartIcon sx={{ fontSize: 18, color: 'custom.ink' }} />
              </Box>
            </Tooltip>
          </Box>

          <Box
            sx={{
              mt: 'auto',
              py: '14px',
              display: 'flex',
              justifyContent: 'center',
              borderTop: '1px solid',
              borderColor: 'custom.line',
            }}
          >
            <AgentPulse size={6} live={isLive} />
          </Box>
        </>
      )}
    </Drawer>
  )
}
